import styled from 'styled-components'
import colors from '../../../assets/colors'
import { tokens } from '../../../assets/tokens'

const SatisfactionSurveyTable = styled.div`
  && {
    padding: 16px;
    background-color: ${colors.white};
    border-radius: 6px;
    box-shadow: 0px 4px 6px rgba(98, 102, 113, 0.06), 0px 2px 2px rgba(98, 102, 113, 0.06);
  }
  .satisfaction_table {
    
    .table_head {
      border: unset;
      .row {
        .row_element {
          text-align: center;
          padding: 0 6px 12px !important;
          font-size: 13px;
          font-weight: 500;
          line-height: 20px;
          color: ${tokens.color.text.secondary};
          background-color: white !important;
          border-bottom: 0;
        }
        .row_element:first-child {
          text-align: left !important;
        }
        .header_icon_container {
          position: relative;
          display: inline-block;
          width: 20px;
          height: 20px;
          margin-right: 4px;
          vertical-align: middle;
          
          .satisfaction_icon {
            width: 20px;
            height: 20px;
          }
        }
        /* Título del bloque con la escala de las estadísticas de talent (antes 18/700) */
        .factor_name_header {
          padding-left: 0 !important;
          font-size: 16px;
          font-weight: 600;
          line-height: 24px;
          color: ${tokens.color.text.primary};
        }
      }
    }
    .table_body {
      .row {
        .row_element {
          padding: 6px !important;
            
          .factor_number {
            border-radius: 100%;
            display: inline-block;
            background-color: #F2F2F4;
            width: 24px;
            height: 24px;
            line-height: 24px;
            text-align: center;
            margin: 0 8px 0 0;
            font-size: 12px;
            font-weight: 500;
            color: #7A808D;
          }
          
          .stat_container {
            border-radius: 12px;
          }
          /* Cifra centrada dentro del círculo (antes quedaba pegada al borde izquierdo) */
          .value {
            width: 24px;
            height: 24px;
            line-height: 24px;
            border-radius: 100%;
            display: inline-block;
            margin: 2px;
            font-size: 12px;
            font-weight: 500;
            text-align: center;
            color: white;
          }
          .value_superAgree {
            background-color: ${props => props.colors.superAgree + 45};
          }
          .value_superAgree.max_stat_value {
            background-color: ${props => props.colors.superAgree};
          }
          .value_agree {
            background-color: ${props => props.colors.agree + 45};
          }
          .value_agree.max_stat_value {
            background-color: ${props => props.colors.agree};
          }
          .value_littleDisagree {
            background-color: ${props => props.colors.littleDisagree + 45};
          }
          .value_littleDisagree.max_stat_value {
            background-color: ${props => props.colors.littleDisagree};
          }
          .value_disagree {
            background-color: ${props => props.colors.disagree + 45};
          }
          .value_disagree.max_stat_value {
            background-color: ${props => props.colors.disagree};
          }
         
        }
        
        .last_row_cell {
          border-bottom: 0;
        }
    
        .factor_name {
          background-color: transparent;
          text-align: left !important;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          color: ${tokens.color.text.primary};
        }
        
        .superAgree {
          background-color: ${props => props.colors.superAgree + 12};
          color: #37bc6a;
        }
        .superAgree.max_stat_container {
          background-color: ${props => props.colors.superAgree + 50};
        }

        .agree {
          background-color: ${props => props.colors.agree + 12};
          color: #FAB830;
        }
        .agree.max_stat_container {
          background-color: ${props => props.colors.agree + 50}!important;
        }

        .littleDisagree {
          background-color: ${props => props.colors.littleDisagree + 12};
          color: #F87A26;
        }
        .littleDisagree.max_stat_container {
          background-color: ${props => props.colors.littleDisagree + 50};
        }

        .disagree {
          background-color: ${props => props.colors.disagree + 12};
          color: #F4304A;
        }
        .disagree.max_stat_container {
          background-color: ${props => props.colors.disagree + 50};
        }
      }
    }
  }

`

export default SatisfactionSurveyTable
